/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddMemberInputDto { 
    fullName?: string | null;
    branchId?: number | null;
    isActive?: boolean;
    documentTypeId: number;
    comment?: string | null;
    documentFileName?: string | null;
    documentId: string;
    idNumber?: string | null;
    creditUnionId?: number;
    readonly surname?: string | null;
    readonly middleName?: string | null;
    readonly name?: string | null;
}

